import { render, staticRenderFns } from "./ProgrammeEditor.vue?vue&type=template&id=8f967810&"
import script from "./ProgrammeEditor.vue?vue&type=script&lang=js&"
export * from "./ProgrammeEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammeEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports